import Icon from '../components/Icon.vue'

Icon.register({
  'volume-mute': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M215 71.1L126.1 160H24C10.7 160 0 170.7 0 184V328C0 341.3 10.7 352 24 352H126.1L215 440.9C230.1 456 256 445.4 256 424V88C256 66.6 230 56 215 71.1zM461.6 256L507.3 210.4C513.6 204.1 513.6 193.8 507.3 187.5L484.5 164.7C478.2 158.4 467.9 158.4 461.6 164.7L416 210.4 370.4 164.7C364.1 158.4 353.8 158.4 347.5 164.7L324.7 187.5C318.4 193.8 318.4 204.1 324.7 210.4L370.4 256 324.7 301.6C318.4 307.9 318.4 318.1 324.7 324.4L347.6 347.3C353.9 353.6 364.1 353.6 370.4 347.3L416 301.6 461.6 347.3C467.9 353.6 478.2 353.6 484.5 347.3L507.3 324.5C513.6 318.2 513.6 307.9 507.3 301.6L461.6 256z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/volume-mute.js
// module id = 9taZ
// module chunks = 144